// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @vendors
const { get } = require('lodash');

// @ constants
const actionTypes = require('constants/actionTypes');

const reset = () => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_RESET
});

const validateStep = () => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_VALIDATE_STEP
});

const addFileDni = file => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_ADD_FILE_DNI,
    payload: file
});

const addFileDniAndValidate = file => dispatch => {
    dispatch(addFileDni(file));
    dispatch(validateStep());
}

const addFileFamilyBook = file => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_ADD_FILE_FAMILY_BOOK,
    payload: file
});

const addFileFamilyBookAndValidate = file => dispatch => {
    dispatch(addFileFamilyBook(file));
    dispatch(validateStep());
}

const addNewContainerForFile = () => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_ADD_NEW_CONTAINER_FOR_FILE
});

const deleteFileDni = file => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_DELETE_FILE_DNI,
    payload: file
});

const deleteFileDniAndValidate = file => dispatch => {
    dispatch(deleteFileDni(file));
    dispatch(validateStep());
}

const deleteFileFamilyBook = file => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_DELETE_FILE_FAMILY_BOOK,
    payload: file
});

const deleteFileFamilyBookAndValidate = file => dispatch => {
    dispatch(deleteFileFamilyBook(file));
    dispatch(validateStep());
}

const uploadFilesInProgress = () => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_UPLOAD_REQUEST
});

const uploadFilesSuccess = response => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_UPLOAD_SUCCESS,
    payload: {
        response
    }
});

const uploadFilesFailure = errorDescription => ({
    type: actionTypes.UPLOAD_DOCUMENTS_OPEN_YOUNG_UPLOAD_FAILURE,
    payload: {
        errorDescription
    }
});

const sendFiles = (immCard, immCardBeneficiary) => (dispatch, getState) => {
    if (!getState().uploadDocumentsOpenYoung.get('isFetching')) {
        let familyBookPages = [];
        
        const files = getState().uploadDocumentsOpenYoung.get('files').toJS();
        const dniFrontType = Object.keys(get(files, 'dni.dniDocumentFront')).length >=  2 ? get(files, 'dni.dniDocumentFront.data.file.type').split('/')[1]:false;
        const dniFrontFile = Object.keys(get(files, 'dni.dniDocumentFront')).length >=  2 ? get(files, 'dni.dniDocumentFront.data.base64').split(',')[1]:false;
        const dniBackType = Object.keys(get(files, 'dni.dniDocumentBack')).length >=  2 ? get(files, 'dni.dniDocumentBack.data.file.type').split('/')[1]:false;
        const dniBackFile = Object.keys(get(files, 'dni.dniDocumentBack')).length >=  2 ? get(files, 'dni.dniDocumentBack.data.base64').split(',')[1]:false;
        
        Object.keys(get(files, 'familyBook.0.data')).length >=  2 && get(files, 'familyBook').forEach(file => {
            if (!!file.data.base64) {
                familyBookPages.push(file.data.base64.split(',')[1]);
            }
        });
        const immAccount = getState().accounts.get('byId').filter(account => 
            account.get('contractNumber') === immCard.get('associatedAccountShort')
        );
        const accountIban = immAccount.first().get('iban');
        const beneficiaryCode = immCardBeneficiary.get('personCode');
        const beneficiaryType = immCardBeneficiary.get('personType');
        const beneficiaryFullName = immCardBeneficiary.get('personName').trim().split(' ');
        const beneficiaryFirstName = beneficiaryFullName[beneficiaryFullName.length - 1];
        const beneficiaryLastName = beneficiaryFullName[0];
        const payload = {
            accountNumber: accountIban,
            cliente: {
                name: beneficiaryFirstName,
                surname: beneficiaryLastName
            },
            numeroExpediente: immCard.get('number').replace(/\s/g,''),
            persona: {
                codigodepersona: beneficiaryCode,
                tipodepersona: beneficiaryType
            },
        }

        const dniPayload = ((dniFrontFile && dniFrontType) || (dniBackFile && dniBackType)) &&  {
            ...payload,
            front: {
                file: dniFrontFile,
                fileExtension: dniFrontType,
            },
            back: {
                file: dniBackFile,
                fileExtension: dniBackType,
            }
        }

        const familyBookPayload = familyBookPages.length >= 1  && {
            ...payload,
            paginas: familyBookPages,
        }

        dispatch(uploadFilesInProgress());

        const dniPromise = dniPayload && APIPost({
            dispatch,
            endpoint: 'openYoungUploadDni',
            params: {
                header: {
                    version: 2
                },
                query: dniPayload,
            }
        });

        const familyBookPromise = familyBookPayload && APIPost({
            dispatch,
            endpoint: 'openYoungUploadFamilyBook',
            params: {
                header: {
                    version: 2
                },
                query: familyBookPayload
            }
        });

        return (familyBookPromise || dniPromise) && Promise.all([dniPromise, familyBookPromise])
            .then(responses => {
                dispatch(uploadFilesSuccess(responses));
            })
            .catch(error => {
                dispatch(uploadFilesFailure(error));
            });
    }
};

module.exports = {
    addFileDniAndValidate,
    addFileFamilyBookAndValidate,
    addNewContainerForFile,
    deleteFileDniAndValidate,
    deleteFileFamilyBookAndValidate,
    reset,
    sendFiles,
    validateStep,
};
